import { render, staticRenderFns } from "./AuthorIllusts.vue?vue&type=template&id=b462beaa&scoped=true"
import script from "./AuthorIllusts.vue?vue&type=script&lang=js"
export * from "./AuthorIllusts.vue?vue&type=script&lang=js"
import style0 from "./AuthorIllusts.vue?vue&type=style&index=0&id=b462beaa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b462beaa",
  null
  
)

export default component.exports